"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styled_components_1 = require("styled-components");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var palette_1 = require("../../../constants/palette");

var zIndex_1 = require("../../../systems/zIndex");

var MobileHeaderLogo = styled_components_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-height: 26px;\n  max-width: 120px;\n  margin-left: 10px;\n"], ["\n  max-height: 26px;\n  max-width: 120px;\n  margin-left: 10px;\n"])));
var MobileVerticalRule = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-left: 1px solid ", ";\n  display: inline-block;\n  height: 35px;\n  margin-left: 10px;\n  margin-right: 10px;\n"], ["\n  border-left: 1px solid ", ";\n  display: inline-block;\n  height: 35px;\n  margin-left: 10px;\n  margin-right: 10px;\n"])), palette_1.default.lightGrey);
var MobileHeaderDOM = styled_components_1.default.header(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  z-index: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: ", ";\n  height: 55px;\n  overflow: hidden;\n  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.06);\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  z-index: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: ", ";\n  height: 55px;\n  overflow: hidden;\n  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.06);\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n  align-items: center;\n"])), zIndex_1.default.Header, palette_1.default.white);
var WrappingLabel = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  word-wrap: break-spaces;\n  width: 120px;\n  color: ", ";\n  font-size: 12px;\n"], ["\n  word-wrap: break-spaces;\n  width: 120px;\n  color: ", ";\n  font-size: 12px;\n"])), palette_1.default.medGrey);
var HamburgerIcon = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-radius: 5px;\n  margin-left: auto;\n  margin-right: 10px;\n  cursor: pointer;\n  padding: 10px 12px;\n"], ["\n  border: 1px solid ", ";\n  border-radius: 5px;\n  margin-left: auto;\n  margin-right: 10px;\n  cursor: pointer;\n  padding: 10px 12px;\n"])), palette_1.default.medGrey);

exports.toggleMobileMenu = function () {
  // TODO: refactor/animations
  var mobileNav = document.getElementById('mobile-navigation');
  if (mobileNav) mobileNav.classList.toggle('hidden');
};

var MobileHeader =
/** @class */
function (_super) {
  __extends(MobileHeader, _super);

  function MobileHeader(props) {
    return _super.call(this, props) || this;
  }

  MobileHeader.prototype.render = function () {
    return React.createElement(MobileHeaderDOM, null, React.createElement(MobileHeaderLogo, {
      src: this.props.logo,
      alt: "Logo: " + this.props.clubName
    }), React.createElement(MobileVerticalRule, null), React.createElement(WrappingLabel, null, this.props.locationName), React.createElement(HamburgerIcon, {
      onClick: exports.toggleMobileMenu
    }, React.createElement(react_fontawesome_1.FontAwesomeIcon, {
      icon: free_solid_svg_icons_1.faBars,
      color: palette_1.default.medGrey
    })));
  };

  return MobileHeader;
}(React.Component);

exports.default = MobileHeader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;